import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("sku_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem("sku_token");
    setToken(null);
    setUser(null);
  }, []);

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!token) {
        if (active) { setUser(null); setLoading(false); }
        return;
      }
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (active) setUser(data);
      } catch {
        // Do NOT wipe the token here — a stale/background check must not log the user out.
        if (active) setUser(null);
      } finally {
        if (active) setLoading(false);
      }
    };
    check();
    return () => { active = false; };
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("sku_token", data.access_token);
    setUser(data.user);
    setToken(data.access_token);
    return data;
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
